
import { defineComponent, ref, computed, onMounted } from 'vue'
import NetworkPoints from '@/components/network-point/Points.vue'
import { Search } from 'vant'
import { useStore } from 'vuex'

export default defineComponent({
  name: 'Networkpoint-List',
  components: {
    NetworkPoints,
    VanSearch: Search,
  },
  props: {
    autoFocus: Boolean,
  },
  emits: ['searchFocus', 'searchBlur'],
  setup(props, context) {
    const keywords = ref('')
    const store = useStore()
    const isFocus = ref(false)
    const searchbox = ref<HTMLElement>()
    const navHeight = 44
    const appStatusBarHeight = computed<number>(() => store.state.appStatusBarHeight)
    // 不这样写就无法展示没有更多了的信息
    const fHeight = `calc(100% - ${appStatusBarHeight.value + navHeight + 50}px)`

    // let timer: any = null
    // const clearTimer = () => {
    //   if (timer) {
    //     clearTimeout(timer)
    //   }
    // }
    // watch(keywords, (newv) => {
    //   clearTimer()
    //   timer = setTimeout(() => {
    //     context.emit('changeKeywords', newv)
    //   }, 300)
    // })
    onMounted(() => {
      if (props.autoFocus) {
        searchbox.value.focus()
      }
    })
    const onFocus = () => {
      isFocus.value = true
      context.emit('searchFocus')
    }
    const onBlur = () => {
      isFocus.value = false
      context.emit('searchBlur', keywords.value)
    }
    const onClickItem = () => {
      keywords.value = ''
      onBlur()
    }
    const onCancel = () => {
      searchbox.value.blur()
      context.emit('searchBlur', keywords.value)
    }
    return {
      fHeight,
      onClickItem,
      searchbox,
      isFocus,
      onBlur,
      onFocus,
      keywords,
      onCancel,
    }
  },
})
